<template>
  <div ref="addTagUtil" style="max-height: 150px; overflow-y: auto; min-width: 430px;">
    <div v-for="(item, index) in list" :key="index" :class="{'mt-5': list.length>1}">

      <template>
        <span class="ml-5">
          <input type="text" class="tc-15-input-text" :placeholder="$t('cos.tag_key')" v-model.trim="item.Key">

          <input type="text" class="tc-15-input-text" :placeholder="$t('cos.tag_value')"
            v-model.trim="item.Value" style="margin-left: 10px">
        </span>
      </template>

      <span class="ml-5">
        <a href="javascript:;" @click="addTagItem(index)">
          <qc-icon type="add"></qc-icon>
        </a>
        <a href="javascript:;" @click="delTagItem(index)" v-if="index != 0">
          <qc-icon type="remove"></qc-icon>
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import { tips } from '@/scripts/tools/utils';

export default {
  name: 'addTagUtil',
  model: {
    prop: 'list',
    event: 'change',
  },
  props: {
    list: Array,
  },
  methods: {
    addTagItem(index) {
      if (this.list.length >= 10) {
        tips.error(this.$t('error.up_to_10_tags_are_allowed'));
        return;
      }
      this.list.splice(index + 1, 0, { Key: '', Value: '' });
      this.change();
    },
    delTagItem(index) {
      if (this.list.length === 1) {
        this.list.splice(index, 1, { Key: '', Value: '' });
      } else {
        this.list.splice(index, 1);
      }
      this.change();
    },
    change() {
      this.$emit('change', this.list);
    },
  },
};
</script>
